import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Services from './pages/Services';
import About from './pages/About';
import Blog from './pages/Blog';
import NotFound from './pages/NotFound';
import { I18nProvider } from './i18n';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import WhatsAppBot from './pages/WhatsAppBot';
import Onboard from './pages/Onboard';
import OnboardSuccess from './pages/OnboardSuccess';

function App() {
  return (
    <Router>
      <I18nProvider>
        <div className="flex flex-col min-h-screen">
          <ScrollToTop />
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/whatsapp-bot" element={<WhatsAppBot />} />
              <Route path="/onboard" element={<Onboard />} />
              <Route path="/onboard/success" element={<OnboardSuccess />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </I18nProvider>
    </Router>
  );
}

export default App;
